import React, { useEffect } from "react";
import "./ChangesSavedModal.css";
import { Modal } from "react-bootstrap";
import { titles } from "constants/titles";
import { ChangesSavedIcon } from "assets/SVGs/SVGs";

const ChangesSavedModal = ({ show, setShow, onClose, titleText = "", isAutoHide = true }) => {
  useEffect(() => {
    let timer;
    if (isAutoHide) {
      timer = setTimeout(() => {
        if (onClose) {
          onClose();
        } else {
          setShow(false);
        }
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setShow(false);
    }
  };

  return (
    <Modal
      backdrop="true"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      className="csm_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="csm_body">
        <div className="csm_content_container">
          <div className="csm_icon_container">
            <ChangesSavedIcon />
          </div>
          <p className="csm_text">{titleText ? titleText : titles?.changes_saved}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangesSavedModal;
